import React from 'react';

const ICON_PATHS = {
  sun: (
    <>
      <circle cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 2v2.5M12 19.5V22M4.5 12H2M22 12h-2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M18.7 5.3l-1.8 1.8M7.1 16.9l-1.8 1.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  ),
  moon: (
    <path
      d="M16.8 14.08A7 7 0 0 1 9.92 7.2c0-1.32.36-2.55.99-3.6a7 7 0 1 0 9.49 9.49 7.22 7.22 0 0 1-3.6.99z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
  home: (
    <>
      <path
        d="M4.2 10.5 12 4.1l7.8 6.4v8.5a1 1 0 0 1-1 1h-4.4v-5.4H9.6V20a1 1 0 0 1-1 1H4.3a1 1 0 0 1-1-1z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
    </>
  ),
  calculator: (
    <>
      <rect x="6" y="3.5" width="12" height="17" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <rect x="8" y="6" width="8" height="3" rx="0.6" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="9.5" cy="12.5" r="0.9" fill="currentColor" />
      <circle cx="12" cy="12.5" r="0.9" fill="currentColor" />
      <circle cx="14.5" cy="12.5" r="0.9" fill="currentColor" />
      <circle cx="9.5" cy="15.5" r="0.9" fill="currentColor" />
      <circle cx="12" cy="15.5" r="0.9" fill="currentColor" />
      <circle cx="14.5" cy="15.5" r="0.9" fill="currentColor" />
      <rect x="11.3" y="18" width="3.4" height="0.9" rx="0.45" fill="currentColor" />
    </>
  ),
  scale: (
    <>
      <path d="M12 4v14.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M7.2 6.5h9.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M6 10.5 8.4 6l2.4 4.5c0 1.66-1.34 3-3 3s-3-1.34-3-3z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M15.2 10.5 17.6 6l2.4 4.5c0 1.66-1.34 3-3 3s-3-1.34-3-3z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M9.5 20h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="7.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" />
    </>
  ),
  clipboard: (
    <>
      <rect x="6.5" y="4.5" width="11" height="15" rx="1.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9.5 3.5h5a1 1 0 0 1 1 1v2.5H8.5V4.5a1 1 0 0 1 1-1z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M9.5 10h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M9.5 13.5h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  ),
  bolt: (
    <path
      d="M13.8 2.5 6.7 12h4.5l-1 9.5 7.1-9.5H12.7z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  ),
  chart: (
    <>
      <rect x="5.5" y="10.5" width="2.8" height="8" rx="0.8" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <rect x="10.6" y="7.5" width="2.8" height="11" rx="0.8" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <rect x="15.7" y="4.5" width="2.8" height="14" rx="0.8" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M4.5 20.5h15" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  ),
  book: (
    <>
      <path d="M6 5.5c1.8-.9 3.5-1.3 6-1.3s4.2.4 6 1.3v13.2c-1.8-.9-3.5-1.3-6-1.3s-4.2.4-6 1.3z" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 4.2v13.2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  ),
  wallet: (
    <>
      <path d="M4.5 7.5a2 2 0 0 1 2-2h11a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-11a2 2 0 0 1-2-2z" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M17.5 10h-3a1.5 1.5 0 0 0 0 3h3z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="15.4" cy="11.5" r="0.9" fill="currentColor" />
    </>
  ),
  lightbulb: (
    <>
      <path
        d="M12 4.5a4.5 4.5 0 0 1 4.5 4.5c0 1.5-.7 2.8-1.8 3.7-.7.6-1.2 1.4-1.3 2.4h-2.8c-.1-1-.6-1.8-1.3-2.4A4.6 4.6 0 0 1 7.5 9a4.5 4.5 0 0 1 4.5-4.5z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      />
      <path d="M10 16h4M10.5 18h3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  ),
  lock: (
    <>
      <rect x="6.5" y="10.5" width="11" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9.5 10.5V7.8a2.5 2.5 0 0 1 5 0v2.7" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="15.5" r="1.2" fill="currentColor" />
      <path d="M12 16.7v1.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </>
  ),
  sparkle: (
    <>
      <path d="M12 4.5 13 7l2.5 1-2.5 1-1 2.5-1-2.5-2.5-1 2.5-1z" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      <path d="m7.5 13.5.6 1.5 1.5.6-1.5.6-.6 1.5-.6-1.5-1.5-.6 1.5-.6zM16.5 13.5l.6 1.5 1.5.6-1.5.6-.6 1.5-.6-1.5-1.5-.6 1.5-.6z" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
    </>
  ),
  gamepad: (
    <>
      <rect x="4.5" y="9" width="15" height="8" rx="3.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M9 13.5h-2m1 1v-2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="15.5" cy="12.5" r="0.9" fill="currentColor" />
      <circle cx="17" cy="14" r="0.9" fill="currentColor" />
    </>
  ),
  phone: (
    <>
      <rect x="8" y="3" width="8" height="18" rx="1.6" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="18" r="0.8" fill="currentColor" />
      <rect x="10" y="5" width="4" height="9" rx="0.8" fill="none" stroke="currentColor" strokeWidth="1.4" />
    </>
  ),
  trophy: (
    <>
      <path d="M8 4.5h8v2a4 4 0 0 1-4 4 4 4 0 0 1-4-4z" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M12 10.5v2.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M9.5 15h5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M18 4.5h2l-.3 2.8a3 3 0 0 1-3 2.7" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M6 4.5H4l.3 2.8a3 3 0 0 0 3 2.7" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </>
  ),
  shield: (
    <path
      d="M12 3.2 5 5.5v5.7c0 4 3 7.7 7 9 4-1.3 7-5 7-9V5.5z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  ),
  users: (
    <>
      <circle cx="9" cy="9.5" r="2.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="15" cy="8.5" r="2.1" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M5.5 17.8a3.8 3.8 0 0 1 3.7-3.3h2a3.8 3.8 0 0 1 3.8 3.3v1.2H5.5z" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <path d="M13.2 18h5.3v-.7a3.3 3.3 0 0 0-3.3-3.3h-1.4" fill="none" stroke="currentColor" strokeWidth="1.6" />
    </>
  ),
  cookie: (
    <>
      <path
        d="M20 12.5a8 8 0 1 1-7-8 2.5 2.5 0 0 0 2.8 2.8 2.5 2.5 0 0 0 2.8 2.8 2.5 2.5 0 0 0 1.4 2.4z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="10.5" cy="12" r="0.9" fill="currentColor" />
      <circle cx="14.5" cy="15" r="0.7" fill="currentColor" />
      <circle cx="8.8" cy="8.8" r="0.7" fill="currentColor" />
    </>
  )
};

function Icon({ name, size = 24, title, className = '' }) {
  const path = ICON_PATHS[name];

  if (!path) {
    return null;
  }

  const labelledProps = title
    ? { role: 'img', 'aria-label': title }
    : { 'aria-hidden': 'true' };

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...labelledProps}
    >
      {title ? <title>{title}</title> : null}
      {path}
    </svg>
  );
}

export default Icon;
